import { all } from 'country-codes-list'

export const Countries = all()
